import Joi from "joi";

function ItemValidationSchema(fieldName, name) {
    const schema = {
        [fieldName]: Joi.string().min(2).max(100).required().messages({
            "string.min": `${name} must be at least 2 characters`,
            "string.max": `${name} cannot exceed 100 characters`,
            "any.required": `${name} is required`,
            "string.empty": `${name} cannot be empty`,
        }),
    };
    return Joi.object(schema);
}

export default ItemValidationSchema;
